package fr.labodoc.healthProfessional.webApp.data.error

sealed class DataSourceError
